export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9305.e457e242.jpg";